import { render, staticRenderFns } from "./GameEndPhase.vue?vue&type=template&id=0526b3a0&scoped=true&"
import script from "./GameEndPhase.vue?vue&type=script&lang=js&"
export * from "./GameEndPhase.vue?vue&type=script&lang=js&"
import style0 from "./GameEndPhase.vue?vue&type=style&index=0&id=0526b3a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526b3a0",
  null
  
)

export default component.exports